export default "__VITE_ASSET__BZzOYCBw__"